import { mediator } from '@ioc/mediator'
import { RequestData } from 'mediatr-ts'

export class RefreshOverleafStatusCommand extends RequestData<void> {
  constructor() {
    super()
  }
}

export const refreshOverleafStatus = () => mediator.send(new RefreshOverleafStatusCommand())
